import React, { useRef, useState } from "react";
import { BillsPaymentList } from "./BillsPaymentList/BillsPaymentList";
import styles from "./BillsPayment.module.css";
import { BillsPaymentDetails } from "./BillsPaymentDetails/BillsPaymentDetails";
import Header from "../Header/Header";
import SearchAndFilter from "../SearchAndFilter/SearchAndFilter";
import { IMAGE_PATH, PRODUCT } from "../../Utils/variables";
import { Button } from "evergreen-ui";
import { ModalComp } from "../PO/Modal/ModalComp";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CustomButton from "../Common/CustomButton";
export const BillsPayment = () => {
  const [detailId, setDetailId] = useState();
  const [communityId, setCommnityId] = useState();
  const [isNormalBill, setIsNormalBill] = useState('')
  const [getFilterData, setgetFilterData] = useState({});
  const [searched, setSearched] = useState("");
  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [disablebtn, setDisableBtn] = useState(false);
  const handleDisablebtn = () => setDisableBtn(true);
  const [detail, setDetail] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const navigate = useNavigate();
  const billListingRef = useRef();

  const FilterData = (
    Communities,
    manageBy,
    closingOnstart,
    closingOnend,
    postedOnstart,
    postedOnend
  ) => {
    let obj = {
      Communities,
      manageBy,
      closingOnstart,
      closingOnend,
      postedOnstart,
      postedOnend,
    };
    setgetFilterData(obj);
  };
  const searchFucntion = (serchQueryu) => {
    setSearched(serchQueryu);
  };
  const handleDetail = (billId, commId, normalBill) => {
    setDetailId(billId);
    setCommnityId(commId);
    setIsNormalBill(normalBill)
  };
  document.title = PRODUCT + " - Bills & Payments";

  const deleteBill = (payload) => {
    toast.dismiss();
    try {
      setIsDeleting(true);
      fetch(
        process.env.REACT_APP_API_URL + "/api/vendorpo/deleteVendorBillsByID",
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: { "content-type": "application/json" },
        }
      )
        .then((response) => response.json())
        .then((result) => {
          setIsDeleting(false);
          setOpenDeleteModal(false)
          const response = result?.response;
          if (response?.status) {
            if (
              billListingRef.current &&
              billListingRef.current.triggerMyFunction
            ) {
              billListingRef.current.triggerMyFunction();
            }
            toast.success(response.message);
          }
        })
        .catch((err) => {
          setIsDeleting(false);
          console.log(err);
        });
    } catch (error) {
      setIsDeleting(false);
      console.log(error);
    }
  };

  return (
    <div className="routingSubContainer">
      <Header title={"Bills & Payments"} />
      <div className={styles.createbillSearchWrapper}>
        <SearchAndFilter
          FilterData={FilterData}
          closefilter={false}
          searchFucntion={searchFucntion}
        />
        {/* <div className={styles.rightTopDivBill}>
          <Button
            className="poppinFont"
            marginRight={16}
            onClick={onOpenModal}
            width={100}
            height={40}
            float="right"
          >
            Submit Bill
          </Button>
        </div> */}
        <div className={styles.rightTopDivBill}>
          <CustomButton
            onClick={() => {
              navigate("/createbill", { state: { hide: false } });
            }}
          >
            <span>Create Bill</span>{" "}
            <img
              style={{ marginLeft: "5px" }}
              src={IMAGE_PATH + "plus-icon.svg"}
              alt=""
            />
          </CustomButton>
        </div>
      </div>
      <ModalComp
        open={open}
        onOpenModal={onOpenModal}
        onCloseModal={onCloseModal}
        handleDisablebtn={handleDisablebtn}
        detail={detail}
      />
      <div className={styles.mainDivPO}>
        <div className={styles.leftDivPO}>
          <BillsPaymentList
            handleDetail={handleDetail}
            getFilterData={getFilterData}
            searched={searched}
            modalState={open}
            setIsDeleting={setIsDeleting}
            ref={billListingRef}
          />
        </div>
        <div className={styles.rightDivPO}>
          <BillsPaymentDetails
            detailId={detailId}
            communityId={communityId}
            isNormalBill={isNormalBill}
            getFilterData={getFilterData}
            deleteBill={deleteBill}
            isDeleting={isDeleting}
            openDeleteModal={openDeleteModal}
            setOpenDeleteModal={setOpenDeleteModal}
          />
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};
